export default __webpack_public_path__ + "static/media/Group 6523@3x.7ec3e293.png";